import { Box } from 'grommet';
import React from 'react';
import { DataTable, Spinner } from '../components';
import { UserProfile } from '../components/UserProfile';
import { useUserContext } from '../contexts/UserContext';

const User = () => {
  const {
    state: { user, dataTable, loading },
  } = useUserContext();
  return (
    <Box align="center" pad="small">
      {loading ? <Spinner /> : <UserProfile {...user} />}
      <DataTable
        columns={dataTable.columns}
        data={dataTable.data}
        loading={loading}
      />
    </Box>
  );
};

export { User };
